<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']"
  titleText="i18n.core.navigation.export-jobs"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <div class="header-wrapper">
      <app-client-autocomplete [selectedClient]="selectedClient"
        (selectedClientChange)="onClientSelected($event)"
        [showSystem]="true"
        class="client-autocomplete me-2">
      </app-client-autocomplete>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-4">
    <ejs-grid #grid
      rowHeight="38"
      class="grid-with-toolbar grid-no-filter grid-configuration"
      [dataSource]="data"
      [allowSorting]="true"
      [allowPaging]="true"
      [pageSettings]='pageSettings'
      [allowFiltering]="true"
      [filterSettings]="filterSettings"
      (rowSelected)="onRowSelected($event)"
      (dataBound)="onDataBound()">
      <ng-template #toolbarTemplate let-data>
        <ejs-toolbar>
          <e-items>
            <e-item
              [text]="'i18n.domain.export-jobs.overview.add-button-text' | translate"
              prefixIcon='e-icons icon-add' (click)="addJob()"
              [disabled]="selectedClient == null">
            </e-item>
            <e-item align="Right"
              [tooltipText]="'i18n.domain.export-jobs.overview.refresh-button-text' | translate"
              prefixIcon='e-icons icon-renew' (click)="onRefresh()">
            </e-item>
          </e-items>
        </ejs-toolbar>
      </ng-template>
      <e-columns>
        <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
        <e-column field="company.name" width="180px"
          headerText="{{'i18n.shared.fields.company' | translate}}"
          clipMode="EllipsisWithTooltip"
          type="string"
          [allowSorting]="false">
          <ng-template #template let-data>
            {{getCompanyName(data)}}
          </ng-template>
        </e-column>
        <e-column field="type" width="150px"
          headerText="{{'i18n.domain.export-jobs.fields.type' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{'i18n.domain.export-jobs.enums.export-job-type.' +
            JobTypes[data.type] | translate}}
          </ng-template>
        </e-column>
        <e-column field="fromDate"
          headerText="{{'i18n.domain.export-jobs.fields.month' | translate}}"
          clipMode="EllipsisWithTooltip"
          type="string">
          <ng-template #template let-data>
            {{getDisplayDateTime(data.fromDate)}}
          </ng-template>
        </e-column>
        <e-column field="status"
          headerText="{{'i18n.domain.export-jobs.fields.status' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            <span class="status-bubble {{getStatusClassName(data.status)}}"
              title="{{'i18n.domain.export-jobs.enums.export-job-status.' +
            ExportJobStatus[data.status] | translate}}"></span>
          @if(data.status == ExportJobStatus.Completed) {
            <button type="button" class="e-lib e-btn e-control icon-btn e-icon-btn e-edit-delete e-editbutton"
              data-mdb-ripple-init (click)="downloadFile(data)">
              <span class="e-btn-icon icon-download e-icons"></span>
            </button>
          }
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
  <div class="col-8" [hidden]="exportJob === null">
    <app-export-job-edit-form #exportJobFormComponent
      [exportJob]="exportJob"
      (create)="create($event)"
      (delete)="onDelete()"
      (cancel)="onCancel()">
    </app-export-job-edit-form>
  </div>
</div>
